'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// el should be what wraps all <p>'s... then DropCaps get's the first letter of the first <p>

var DropCaps = function DropCaps(el) {
	_classCallCheck(this, DropCaps);

	this.$el = $(el);

	if (this.$el.length > 0) {
		var $p = this.$el.find('p').first();
		if ($p.length > 0) {
			var pFirstLetterRemoved = $p.text().substr(1, undefined);
			var firstLetter = '<span class="first-letter">' + $p.text().slice(0, 1) + '</span>';
			$p.html('' + firstLetter + pFirstLetterRemoved);
		}
	}
};